import { z } from "zod";
import { isoDateSchema } from "@common/helpers/date";

export const manualTransactionUpdateFieldsSchema = z.object({
    dateOnly: isoDateSchema,
    amount: z
        .number({ invalid_type_error: "Enter an amount" })
        .refine((amount) => amount !== 0, "Enter a non-zero amount"),
    bankDescription: z.string().trim().min(1, "Enter a bank description"),
});

export const updateManualTransactionBodySchema =
    manualTransactionUpdateFieldsSchema
        .partial()
        .refine(
            ({ dateOnly, amount, bankDescription }) =>
                dateOnly !== undefined ||
                amount !== undefined ||
                bankDescription !== undefined,
            { message: "Provide at least one field to update" },
        );

export type UpdateManualTransactionBody = z.infer<
    typeof updateManualTransactionBodySchema
>;
